import { useRef, useState } from 'react';
import { useWebSocketConnection } from './useWebSocketConnection';
import { Telemetry } from 'app/services/telemetry/Telemetry';

export type { WsStatus } from './useWebSocketConnection';

const RING_BUFFER_SIZE = 50;

export type WsMessage = {
  id: string;
  raw: string;
  json?: unknown;
  ts: number;
  direction: 'in' | 'out';
};

type Options = {
  autoReconnect?: boolean;
  extraHeaders?: Record<string, string>;
  buildUrl?: (baseUrl: string, token: string) => string;
};

export function useWebSocketMessages(baseUrl: string, options: Options = {}) {
  const [messages, setMessages] = useState<WsMessage[]>([]);
  const msgCountRef = useRef(0);

  const { status, connect, disconnect } = useWebSocketConnection(baseUrl, {
    ...options,
    onMessage: (event) => {
      const raw = String(event.data);
      let json: unknown | undefined;
      try {
        json = JSON.parse(raw);
      } catch {
        Telemetry.event('net.websocket.message.parse.fail', { domain: 'net', preview: raw.slice(0, 200) }, 'warning');
      }
      const ts = Date.now();
      const id = `${ts}-${++msgCountRef.current}-in`;
      setMessages(prev => [
        { id, raw, json, ts, direction: 'in' as const },
        ...prev.slice(0, RING_BUFFER_SIZE - 1),
      ]);
    },
  });

  return { status, messages, connect, disconnect };
}
